export type StatusNames = {
  name:
    | 'Drög'
    | 'Bíður samþykkis'
    | 'Samþykkt'
    | 'Kostnaður til yfirferðar'
    | 'Til staðfestingar'
    | 'Til samþykktar'
    | 'Lokið'
    | 'Hafnað';
};

export const STATUS_MAPPER = {
  DRAFT: {
    color: 'gray',
    label: 'Drög',
  },
  PENDING: {
    color: 'yellow',
    label: 'Bíður samþykkis',
  },
  AUTHORIZED: {
    color: 'green',
    label: 'Samþykkt',
  },
  COST_IN_REVIEW: {
    color: 'purple',
    label: 'Kostnaður til yfirferðar',
  },
  COST_REVIEWED: {
    color: 'teal',
    label: 'Kostnaður til staðfestingar',
  },
  COST_CONFIRMED: {
    color: 'yellow',
    label: 'Kostnaður til samþykktar',
  },
  COST_APPROVED: {
    color: 'green',
    label: 'Kostnaður samþykktur',
  },
  COST_REVISIT: {
    color: 'orange',
    label: 'Endurskoðun kostnaðar',
  },
  DENIED: {
    color: 'red',
    label: 'Hafnað',
  },
  COMPLETED: {
    color: 'green',
    label: 'Lokið',
  },
};

export const STATUS_OPTIONS = [
  { label: 'Allar', value: 'ALL' },
  // {
  //   label: 'Drög',
  //   value: 'DRAFT',
  // },
  {
    label: 'Bíður samþykkis',
    value: 'PENDING',
  },
  {
    label: 'Samþykkt',
    value: 'AUTHORIZED',
  },
  {
    label: 'Kostnaður til yfirferðar',
    value: 'COST_IN_REVIEW',
  },
  {
    label: 'Kostnaður til staðfestingar',
    value: 'COST_REVIEWED',
  },
  {
    label: 'Kostnaður til samþykktar',
    value: 'COST_CONFIRMED',
  },
  {
    label: 'Kostnaður samþykktur',
    value: 'COST_APPROVED',
  },
  {
    label: 'Endurskoðun kostnaðar',
    value: 'COST_REVISIT',
  },
  {
    label: 'Hafnað',
    value: 'DENIED',
  },
  {
    label: 'Lokið',
    value: 'COMPLETED',
  },
];
